import { PagePaths } from '@revelio/core';

import { steps } from '../report-builder/report-builder-page';

export enum ReportBuilderStep {
  REPORT_TYPE = 0,
  ENTITY = 1,
  CONFIRMATION = 2,
}

export const getReportBuilderPath = (step: ReportBuilderStep) => {
  const reportBuilderPath = (stepIndex: number) => {
    const path = steps[stepIndex]?.path;
    if (path) {
      return `/${PagePaths.REPORT_BUILDER}/${path}`;
    }
    throw new Error(`Step ${stepIndex} not found in report builder.`);
  };

  if (step === ReportBuilderStep.REPORT_TYPE) {
    return reportBuilderPath(0);
  }
  if (step === ReportBuilderStep.ENTITY) {
    return reportBuilderPath(1);
  }
  if (step === ReportBuilderStep.CONFIRMATION) {
    return reportBuilderPath(2);
  }
  throw new Error(`Unknown report builder step: ${step}`);
};
